import instance from './axiosInstance';

const getFeatures = (params, http = instance, options = {}) => http.get('/feature_flags', params, options);
export default getFeatures;
